import { render } from "./qs-sxpr-stp-view.vue?vue&type=template&id=272730e1"
import script from "./qs-sxpr-stp-view.vue?vue&type=script&setup=true&lang=js"
export * from "./qs-sxpr-stp-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/qs-sxpr-stp-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "272730e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('272730e1', __exports__)) {
    api.reload('272730e1', __exports__)
  }
  
  module.hot.accept("./qs-sxpr-stp-view.vue?vue&type=template&id=272730e1", () => {
    api.rerender('272730e1', render)
  })

}


export default __exports__